import { Linkees, CHANNEL_TYPES } from "linkees";
import "linkees/dist/style.css";

const cardItems = [
  {
    title: "TikTok",
    subtitle: "@tedkhercha",
    type: CHANNEL_TYPES.OTHER,
    link: "https://www.tiktok.com/@tedkhercha",
    image: "https://img.icons8.com/color/240/tiktok.png",
  },
  {
    title: "WhatsApp",
    subtitle: "Chat with me",
    type: CHANNEL_TYPES.OTHER,
    link: "https://wa.me/2130555165790",
    image: "https://img.icons8.com/color/240/whatsapp.png",
  },
  {
    title: "Instagram",
    subtitle: "@ted.talks.dz",
    type: CHANNEL_TYPES.INSTAGRAM,
    link: "https://instagram.com/ted.talks.dz",
  },
];

function App() {
  return (
    <Linkees
      name="Ted Khercha"
      cardItems={cardItems}
      customFooter={
        <div className="Footer container">
          <p>Made by Ted.Talks.DZ dev team</p>
        </div>
      }
    />
  );
}

export default App;
